import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {FeedbackThemeResponsePayload} from '../../../../shared/models/api';
import {AppActions} from '../../../actions';

export interface FeedbackThemesState {
  data: FeedbackThemeResponsePayload[] | null;
}

const initialState: FeedbackThemesState = {
  data: null,
};

export const feedbackThemesSlice = createSlice({
  name: '@@eskso/resources/feedbackThemes',
  initialState,
  reducers: {
    setFeedbackThemes: (state, action: PayloadAction<FeedbackThemeResponsePayload[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const feedbackThemes = feedbackThemesSlice.reducer;
